// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"preloader-auth_loaderWrapper__NO1CI","loader":"preloader-auth_loader__OUdVd","rotation":"preloader-auth_rotation__X8YPG"};